import { Box } from "@mui/material";

/** Sidebar-matching SVG icon for page title headers. */
export default function PageHeaderIcon({ src, size = 24, color = "#333" }) {
  return (
    <Box
      component="span"
      aria-hidden
      sx={{
        width: size,
        height: size,
        display: "inline-block",
        flexShrink: 0,
        backgroundColor: color,
        mask: `url(${src}) center / contain no-repeat`,
        WebkitMask: `url(${src}) center / contain no-repeat`,
      }}
    />
  );
}
